import LumaResourceWorkspace, {lumaMoney} from '../../../components/admin/LumaResourceWorkspace';
import AdminTable from '../../../components/admin/AdminTable';
﻿import React, { useEffect, useState } from 'react';
import { TicketPercent } from 'lucide-react';
import { fetchCuponesUsados, CuponUsado } from '../../../services/usedCouponService';
import ExpiredSessionModal from '../../../components/Expired/ExpiredSessionModal';
import Pagination from '../../../components/Pagination/Pagination';
import { useSessionExpiration } from '../../../hooks/useSessionExpiration';
import { useAuth } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';


const ITEMS_PER_PAGE = 10;

const UsedCouponPage: React.FC = () => {
    const [cuponesUsados, setCuponesUsados] = useState<CuponUsado[]>([]);
    const [currentPage, setCurrentPage] = useState(1);

    const { isSessionExpired, setIsSessionExpired } = useSessionExpiration();
    const { logout } = useAuth();
    const navigate = useNavigate();


    const cargarDatos = async () => {
        try {
            const datos = await fetchCuponesUsados();
            // Ordenar por fecha de uso descendente
            const ordenados = datos.sort((a, b) => new Date(b.fecha_uso).getTime() - new Date(a.fecha_uso).getTime());
            setCuponesUsados(ordenados);
        } catch (error) {
            /* Browser diagnostics omitted. */
            setCuponesUsados([]);
        }
    };

    useEffect(() => {
        cargarDatos();
    }, []);

    // Paginación
    const totalPages = Math.ceil(cuponesUsados.length / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const cuponesMostrados = cuponesUsados.slice(startIndex, startIndex + ITEMS_PER_PAGE);

    return <><LumaResourceWorkspace title="Cupones usados" description="Consulta y gestiona la información de tu coworking." group="Cupones" rows={cuponesUsados} columns={[{key:'cupon_codigo',label:'Cupón'},{key:'cliente_nombre',label:'Cliente'},{key:'cupon_descuento_monto',label:'Descuento monto',render:r=>lumaMoney(r.cupon_descuento_monto)},{key:'cupon_descuento_porcentaje',label:'Descuento %'},{key:'fecha_uso',label:'Fecha de uso'}]} idKey="id" nameKey="cupon_codigo" statusKey="estado" canRead={true} onCreate={undefined} onEdit={undefined} onDelete={undefined} extraActions={r=><><button type="button" disabled={!r.cita_id&&!r.cita} onClick={()=>navigate(`/cita-coupon-detalle/${r.cita_id||r.cita}`)}>Detalle de uso</button></>}></LumaResourceWorkspace><ExpiredSessionModal
                    isOpen={isSessionExpired}
                    onClose={async () => {
                        setIsSessionExpired(false);
                        await logout();
                    }}
                /></>;
};

export default UsedCouponPage;


